import { getImage,upload,uploadContractFile,getFile } from "../../api/config/modules/FileController";

const state = {
    getImage: {},
    upload: {},
    uploadContractFile: {},
    getFile: {}
};

const mutations = {
  SET_GETIMAGE: (state, getImage) => {
    state.getImage = getImage;
  },
  SET_UPLOAD: (state, upload) => {
    state.upload = upload;
  },
  SET_UPLOADCONTRACTFILE: (state, uploadContractFile) => {
    state.uploadContractFile = uploadContractFile;
  },
  SET_GETCONTRACTFILE: (state, getFile) => {
    state.getFile = getFile;
  },
};

const actions = {
  GET_GETIMAGE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        getImage(data)
        .then((res) => {
          commit("SET_GETIMAGE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_UPLOAD: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        upload(data)
        .then((res) => {
          commit("SET_UPLOAD", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_UPLOADCONTRACTFILE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        uploadContractFile(data)
        .then((res) => {
          commit("SET_UPLOADCONTRACTFILE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETCONTRACTFILE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      getFile(data)
        .then((res) => {
          commit("SET_GETCONTRACTFILE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
